import Weblinks from './Weblinks.vue';
import WeblinkHeader from './WeblinkHeader.vue';
import moduleId from './moduleId';
import weblinkApi from '@/modules/weblinks/weblinkApi';
import weblinkService from '@/modules/weblinks/weblinkService';

class WebLinkRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/weblinks/:instance',
        name: 'weblinks',
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        components: { default: Weblinks, header: WeblinkHeader },
      },
    ];
  };

  /**
   * Optional method called in beforeEach
   * @param {object} moduleState the vuex state of the current module
   * @param {object} moduleConfig the module configuration where the user tries to navigate to
   * @param {object} from previous route
   * @param {object} to next route
   * @param {function} next function provided by vue router. Can be called to continue at a later stage.
   * @returns {shouldContinue} when shouldContinue is true, the router navigates to the next route (=to)
   */
  async beforeNavigationTo({ moduleState, moduleConfig, from, to, next }) {
    let isWebLinkGroup = moduleConfig.isWebLinkGroup === true;
    let shouldContinue = true;

    console.debug('beforeNavigationTo in WeblinkGroup');
    if (!isWebLinkGroup) {
      let weblinkItem = moduleState.weblinkItems.find((i) => i.instance == to.params.instance);
      let newWindow;
      if (weblinkItem && weblinkItem.intern === 1) {
        newWindow = window.open('', '_blank', 'fullscreen=yes');
      } else {
        newWindow = window.open('', '_blank');
      }

      let modifiedUrl = weblinkService.getWeblinkUrl(weblinkItem);

      if (weblinkItem && weblinkItem.url && weblinkItem.sendAuthentication) {
        const ssoToken = await this.getSsoToken();
        if (ssoToken) {
          let mod = modifiedUrl.indexOf('?') > -1 ? '&' : '?';
          modifiedUrl += `${mod}token=${ssoToken}`;
          //console.debug('weblink url', modifiedUrl);
        }
      }

      shouldContinue = false;
      if (newWindow) {
        try {
          newWindow.location.href = modifiedUrl;
        } catch (err) {
          console.warn('Failed to open weblink in a _blank window', err);
        }
      } else {
        console.warn('Popup was blocked or window.open failed');
      }
    }
    return { shouldContinue };
  }

  async getSsoToken() {
    const response = await weblinkApi.getSSOToken();
    return response && response.data && response.data.token ? response.data.token : '';
  }
}

const routeHandler = new WebLinkRouteHandler();
export default routeHandler;
